import React from "react";

import { Col, Form, Button, Card } from "react-bootstrap";

import FechPostEditClient from "../APP_RESERVATION_FECH_DATA/FechPostEditClient";
import FechGetClientsBySearch from "../APP_RESERVATION_FECH_DATA/FechGetClientsBySearch";
import FechDeleteOneClient from "../APP_RESERVATION_FECH_DATA/FechDeleteOneClient";

import ValidationFormField from "../utils/ValidationFormField";
import Modal from "react-bootstrap/Modal";

//form tylko do podstawowych danych za szkole
class EditClientPopupForm extends React.Component {
  emptyValue = "Brak";
  hourDefaultValue = "Wybierz godzinę";
  dateDefaultValue = "Wybierz datę";
  dayOfTheWeekDefaultValue = "Wybierz dzień tygodnia";
  trainerDefaultValue = "Wybierz trenera";
  classTypeDefaultValue = "Wybierz typ";

  emptyItem = {
    clientId: this.props.clientId,
    nameNewClient: "",
    surnameNewClient: "",
    phoneNewClient: "",
    emailNewClient: "",
  };

  emptyItemError = {
    clientId: this.props.clientId,
    clientName: "",
    nameNewClient: "",
    surnameNewClient: "",
    phoneNewClient: "",
    emailNewClient: "",
  };

  constructor(props) {
    super(props);

    this.state = {
      isError: this.emptyItemError,

      restaddReservationData: {
        successful: false,
        status: "",
        message: "",
        data: [],
      },
      restClientData: {
        successful: false,
        status: "",
        message: "",
        data: [],
      },
      showAddReservationForm: false,
      afterCloseAddReservationForm: false,
      showConfirm: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleShowConfirm = this.handleShowConfirm.bind(this);
    this.handleCloseConfirm = this.handleCloseConfirm.bind(this);
    this.handleCloseReservationFrom =
      this.handleCloseReservationFrom.bind(this);
  }

  async componentDidMount() {
    //this.emptyItem.dateReservation = this.props.dateReservation;
    //this.emptyItem.hourStart = this.props.hour;
    //this.emptyItem.court = this.props.courtId;

    var url = "?page=1&clientId=" + this.props.clientId;
    var response = await FechGetClientsBySearch(this.props.club, url);

    this.setState({ restClientData: response });

    this.setState({ showAddReservationForm: true });
  }

  async componentDidUpdate() {
    //this.emptyItem.dateReservation = this.props.dateReservation;
    //this.emptyItem.hourStart = this.props.hour;
    this.emptyItem.clientId = this.props.clientId;

    if (
      this.state.showAddReservationForm != true &&
      this.state.afterCloseAddReservationForm === false
    ) {
      this.cleanEmptyItem();

      var url = "?page=1&clientId=" + this.props.clientId;
      var response = await FechGetClientsBySearch(this.props.club, url);

      const client = response.data.clientResources.find(
        (obj) => obj.id === this.props.clientId
      );

      this.emptyItem.nameNewClient = client.name;
      this.emptyItem.surnameNewClient = client.surname;
      this.emptyItem.phoneNewClient = client.phone;
      this.emptyItem.emailNewClient = client.email;

      this.setState({ restClientData: response });
      this.setState({ showAddReservationForm: true });
    }
    this.state.afterCloseAddReservationForm = false;
  }

  cleanEmptyItem() {
    this.emptyItem.clientId = "";
    this.emptyItem.nameNewClient = "";
    this.emptyItem.surnameNewClient = "";
    this.emptyItem.phoneNewClient = "";
    this.emptyItem.emailNewClient = "";
  }

  cleanEmptyItemError() {
    this.emptyItemError.clientId = "";
    this.emptyItemError.nameNewClient = "";
    this.emptyItemError.surnameNewClient = "";
    this.emptyItemError.phoneNewClient = "";
    this.emptyItemError.emailNewClient = "";
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.emptyItem[name] = value;

    this.fieldValidation(name, value);
  }

  async deleteClient() {}

  async handleSubmit(event) {
    event.preventDefault();

    for (var key in this.emptyItem) {
      this.fieldValidation(key, this.emptyItem[key]);
    }

    if (ValidationFormField.formValid(this.state.isError)) {
      var response = await FechPostEditClient(this.props.club, this.emptyItem);
      this.setState({
        restEditLesrestaddReservationDatasonsResponseData: response,
      });
      if (response.successful == true) {
        this.state.afterCloseAddReservationForm = true;
        this.setState({ showAddReservationForm: false });
        var refreash = this.props.refresh();
      } else {
        var rr = 3;
      }
    }
  }

  fieldValidation(name, value, compareValue) {
    let isError = { ...this.state.isError };

    var resultValidation = ValidationFormField.formFieldValid(
      isError,
      name,
      value,
      compareValue,
      this.emptyItem
    );

    if (
      this.emptyItem["clientNew"] === false &&
      (name === "nameNewClient" ||
        name === "surnameNewClient" ||
        name === "phoneNewClient" ||
        name === "emailNewClient")
    ) {
      return;
    }
    if (this.emptyItem["clientNew"] === true && name === "clientId") {
      return;
    }
    this.emptyItemError[name] = resultValidation[name];
    this.setState({ isError: this.emptyItemError });
  }

  handleCloseReservationFrom() {
    this.cleanEmptyItem();
    this.cleanEmptyItemError();
    this.setState({ isError: this.emptyItemError });
    this.state.afterCloseAddReservationForm = true;
    this.setState({ showAddReservationForm: false });
  }

  async handleDelete() {
    if (this.state.showConfirm === true) {
      var response = await FechDeleteOneClient(
        this.props.club,
        this.props.clientId
      );
      this.setState({ restaDeleteReservationData: response });
      if (response.successful == true) {
        this.state.afterCloseAddReservationForm = true;
        this.handleCloseConfirm();
        this.handleCloseReservationFrom();
        var refreash = this.props.refresh();
      } else {
        var refreash = this.props.refresh();
      }
    }
  }

  handleCloseConfirm() {
    this.setState({ showConfirm: false });
  }
  handleShowConfirm() {
    this.setState({ showConfirm: true });
  }

  render() {
    const { isError } = this.state;

    if (this.state.restClientData.successful) {
      const client = this.state.restClientData.data.clientResources.find(
        (obj) => obj.id === this.props.clientId
      );
      var clientName = "--";
      if (client != undefined) {
        clientName = client.name + " " + client.surname + " " + client.phone;
      }
    }

    var style = "none";

    return (
      <>
        <Modal
          show={this.state.showAddReservationForm}
          onHide={this.handleCloseReservationFrom}
        >
          <Card border="secondary" style={{ width: "100%" }}>
            <Card.Header>
              Edycja klienta ({clientName}) <br />
            </Card.Header>

            {/* /////////////// */}
            <Button variant="danger" onClick={this.handleShowConfirm}>
              Usuń Klienta
            </Button>

            <Modal
              variant="danger"
              show={this.state.showConfirm}
              onHide={this.handleCloseConfirm}
              animation={false}
            >
              <Modal.Header closeButton>
                <Modal.Title style={{ color: "red", "font-weight": "bold" }}>
                  Czy na pewno chcesz usunąć klienta?
                </Modal.Title>
              </Modal.Header>
              {/* <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body> */}
              <Modal.Footer>
                <Button variant="secondary" onClick={this.handleCloseConfirm}>
                  Zamknij
                </Button>
                <Button variant="danger" onClick={this.handleDelete}>
                  Usuń
                </Button>
              </Modal.Footer>
            </Modal>
            {/* ////////////// */}

            <Card.Body>
              <Card.Text>
                <Form onSubmit={this.handleSubmit}>
                  <Form.Row>
                    <Form.Group as={Col} controlId="formGridName">
                      <Form.Label>Imie</Form.Label>
                      <Form.Control
                        className={
                          isError.nameNewClient.length > 0
                            ? "is-invalid form-control"
                            : "form-control"
                        }
                        id="nameNewClient"
                        name="nameNewClient"
                        value={this.emptyItem.nameNewClient || ""}
                        onChange={this.handleChange}
                      />
                      {isError.nameNewClient.length > 0 && (
                        <span className="invalid-feedback">
                          {isError.nameNewClient}
                        </span>
                      )}
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} controlId="formGridName">
                      <Form.Label>Nazwisko</Form.Label>
                      <Form.Control
                        className={
                          isError.surnameNewClient.length > 0
                            ? "is-invalid form-control"
                            : "form-control"
                        }
                        id="surnameNewClient"
                        name="surnameNewClient"
                        value={this.emptyItem.surnameNewClient || ""}
                        onChange={this.handleChange}
                      />
                      {isError.surnameNewClient.length > 0 && (
                        <span className="invalid-feedback">
                          {isError.surnameNewClient}
                        </span>
                      )}
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} controlId="formGridName">
                      <Form.Label>Telefon</Form.Label>
                      <Form.Control
                        className={
                          isError.phoneNewClient.length > 0
                            ? "is-invalid form-control"
                            : "form-control"
                        }
                        id="phoneNewClient"
                        name="phoneNewClient"
                        value={this.emptyItem.phoneNewClient || ""}
                        onChange={this.handleChange}
                      />
                      {isError.phoneNewClient.length > 0 && (
                        <span className="invalid-feedback">
                          {isError.phoneNewClient}
                        </span>
                      )}
                    </Form.Group>
                  </Form.Row>

                  <Form.Row>
                    <Form.Group as={Col} controlId="formGridName">
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        className={
                          isError.emailNewClient.length > 0
                            ? "is-invalid form-control"
                            : "form-control"
                        }
                        id="emailNewClient"
                        name="emailNewClient"
                        value={this.emptyItem.emailNewClient || ""}
                        onChange={this.handleChange}
                      />
                      {isError.emailNewClient.length > 0 && (
                        <span className="invalid-feedback">
                          {isError.emailNewClient}
                        </span>
                      )}
                    </Form.Group>
                  </Form.Row>

                  {/* <Button  variant="danger" size="lg" onClick={this.handleShowConfirm}>
                    Usuń 
                  </Button> */}

                  <Button
                    variant="success"
                    size="lg"
                    type="submit"
                    style={{ "margin-left": "20px", float: "right" }}
                  >
                    Edytuj
                  </Button>

                  {/* 
                  <Button variant="danger" onClick={this.deleteClient} type="submit" style={{ 'margin-left': '20px', 'float': 'right' }}>
                    Usuń klienta
                  </Button> */}
                </Form>
              </Card.Text>
            </Card.Body>
          </Card>
        </Modal>
      </>
    );
  }
}

export default EditClientPopupForm;
